import { Flex } from 'grid-styled';

export default Flex;